import styles from './Manutencao.module.scss';
import manutencaoIcon from '../../assets/manutencao-icon.png';
import { manutencaoDief } from '../../environments/environment';
import Header from '../../layout/components/header/header';
import Footer from '../../layout/components/footer/footer';

function ManutencaoDief() {
  const { periodoEstimado } = manutencaoDief;

  return (
    <>
      <Header />
      <div className={styles.container}>
        <img src={manutencaoIcon} alt='ícone de manutenção' className={styles.icon} />
        <div className={styles.textContainer}>
          <span className={styles.title}>Sistema em Manutenção</span>
          <br />
          <span className={styles.periodoMessage}>{`Período estimado: ${periodoEstimado}`}</span>

          <p className={styles.text}>
            O sistema está temporariamente indisponível para manutenção. Pedimos desculpas pelo transtorno e agradecemos
            pela compreensão.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ManutencaoDief;
